import { render, staticRenderFns } from "./LoginRegisterSwitcher.vue?vue&type=template&id=61ea5cb0&lang=pug&"
import script from "./LoginRegisterSwitcher.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports